import React from 'react';
import loadable from '@loadable/component';

export default loadable(() => import(/* webpackChunkName: "LazyOrdersChunk" */ './OrdersConnect'), {
    fallback: <div>Loading...</div>,
});
